// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"34af4aa4","885":"ad66882e"}[chunkId] + ".chunk.js";
};